import React, { CSSProperties } from 'react';

import { Box, Typography } from '@mui/material';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import { PurchaseRemarkContainerStyled } from '@components/share/custom/purchaseRemark/style';

type PurchaseRemarkProps = {
  icon: string;
  title: string;
  style?: CSSProperties;
  isFooter?: boolean;
};

const PurchaseRemark = ({ icon, title, style, isFooter = false }: PurchaseRemarkProps) => (
  <PurchaseRemarkContainerStyled style={{ ...style }} isFooter={isFooter} height={isFooter ? '40px' : '50px'}>
    <Box className="container-box">
      <Box sx={{ mr: { md: 2, xs: 1.5 }, display: 'flex', alignItems: 'center' }}>
        <FontAwesomeIcon icon={icon} className="remark-icon" />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography component="p" className="title-text" variant={isFooter ? 'h6' : 'h4'}>
          {title}
        </Typography>
      </Box>
    </Box>
  </PurchaseRemarkContainerStyled>
);

export default PurchaseRemark;
